import React, { useMemo } from 'react';
import LeftCaret from '../icons/left-caret';
import RightCaret from '../icons/right-caret';
import { getMonthNameFromNumber } from './methods';
import MonthPicker from './SimpleCalenderMonth';
import YearPicker from './SimpleCalenderYear';
import CircleRightArrow from 'assets/icons/CircleRightArrow.svg';
import CircleLeftArrow from 'assets/icons/CircleLeftArrow.svg';

export type HeaderProps = {
  month: number;
  year: number;
  minDateValue: number;
  maxDateValue: number;
  nextMonth: () => void;
  prevMonth: () => void;
  onMonthChange: (_: string) => void;
  onYearChange: (_: number) => void;
  disabled: boolean;
};

const Header: React.FC<HeaderProps> = ({
  month,
  year,
  minDateValue,
  maxDateValue,
  nextMonth,
  prevMonth,
  onMonthChange,
  onYearChange,
  disabled,
}) => {
  const fromYear = useMemo(
    () => new Date(minDateValue).getFullYear(),
    [minDateValue],
  );
  const toYear = useMemo(
    () => new Date(maxDateValue).getFullYear(),
    [maxDateValue],
  );

  return (
    <div className="sdp--header mb-1">
      <button
        onClick={prevMonth}
        aria-label="Go to previous month"
        type="button"
        disabled={disabled}
      >
        <img
        src={CircleLeftArrow}
        alt=""
        className='w-6 h-6'
      />
      </button>
      <div className="sdp--header__main text-primary-main">
        <MonthPicker
          disabled={disabled}
          value={getMonthNameFromNumber(month)}
          onChange={onMonthChange}
        />
        <YearPicker
          disabled={disabled}
          fromYear={fromYear}
          toYear={toYear}
          onChange={onYearChange}
          value={year}
        />
      </div>
      <button
        onClick={nextMonth}
        aria-label="Go to next month"
        type="button"
        disabled={disabled}
      >
        <img
        src={CircleRightArrow}
        alt=""
        className='w-6 h-6'
      />
      </button>
    </div>
  );
};

export default Header;
